import { ChangeDetectionStrategy, Component } from '@angular/core';
import { NewsFeedItemContentBase } from '../news-feed-item-content-base';
import { FiStateNames } from '@fi-shared/fi-state-proxy/fi-state-names';

@Component({
    selector: 'fi-news-feed-item-content-checklist',
    templateUrl: './news-feed-item-content-checklist.component.html',
    styleUrls: ['./news-feed-item-content-checklist.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false,
})
export class NewsFeedItemContentChecklistComponent extends NewsFeedItemContentBase {
    FiStateNames = FiStateNames;
}
